import "../Loader.css"
function Loader(){
    return(
      <div className="loader-overlay">
        <div className="truck-spinner">
          <div className="spinner-ring"></div>
          <div className="truck-mask">
            <i className="fas fa-truck-moving truck-move"></i>
          </div>
        </div>
        <p className="loader-text">Goods Delivering...</p>
    </div>
    );
}
export default Loader